import React from 'react'

function SearchAnyProductIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26.826" viewBox="0 0 28 26.826">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Retângulo_244"
            data-name="Retângulo 244"
            width="28"
            height="26.826"
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Grupo_470" data-name="Grupo 470" transform="translate(0 0)">
        <g
          id="Grupo_de_máscara_469"
          data-name="Grupo de máscara 469"
          transform="translate(0 0)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Caminho_236"
            data-name="Caminho 236"
            d="M15.519,24.5A8.789,8.789,0,0,1,8,20.246a8.305,8.305,0,0,1-.936-6.426A8.416,8.416,0,0,1,17.491,7.958a8.59,8.59,0,0,1,6.157,10.37,8.351,8.351,0,0,1-8.129,6.17M15.2,10.464A5.572,5.572,0,0,0,9.74,14.547a5.481,5.481,0,0,0,.627,4.236,5.958,5.958,0,0,0,3.572,2.689,5.654,5.654,0,0,0,7.036-3.87,5.77,5.77,0,0,0-4.2-6.925,6.04,6.04,0,0,0-1.581-.212"
            transform="translate(-2.095 -2.268)"
            fill="#707070"
          />
          <path
            id="Caminho_237"
            data-name="Caminho 237"
            d="M34.725,32.95a1.363,1.363,0,0,1-.911-.349l-7.045-6.279a1.424,1.424,0,0,1-.129-1.986,1.367,1.367,0,0,1,1.952-.131l7.046,6.28a1.423,1.423,0,0,1,.129,1.985,1.37,1.37,0,0,1-1.041.48"
            transform="translate(-8.109 -7.073)"
            fill="#707070"
          />
          <path
            id="Caminho_238"
            data-name="Caminho 238"
            d="M16.487,23.248a1.371,1.371,0,0,1-.358-.048,4.464,4.464,0,0,1-3.18-5.4,1.383,1.383,0,0,1,1.694-1,1.41,1.41,0,0,1,.979,1.723,1.643,1.643,0,0,0,1.222,1.954,1.41,1.41,0,0,1,.979,1.723,1.389,1.389,0,0,1-1.336,1.044"
            transform="translate(-3.949 -4.968)"
            fill="#707070"
          />
          <path
            id="Caminho_239"
            data-name="Caminho 239"
            d="M21.087,33.573a1.334,1.334,0,0,0-1.734-.776A10.912,10.912,0,0,1,8.015,30.552a1.324,1.324,0,0,0-1.892.091,1.379,1.379,0,0,0,.09,1.924,13.576,13.576,0,0,0,14.11,2.769,1.37,1.37,0,0,0,.764-1.763Z"
            transform="translate(-1.781 -8.953)"
            fill="#707070"
          />
          <path
            id="Caminho_240"
            data-name="Caminho 240"
            d="M25.9,9.013a14.171,14.171,0,0,0-3.615-5.337A13.3,13.3,0,0,0,3.286,4.32,13.255,13.255,0,0,0,.079,11.1a1.361,1.361,0,0,0,1.109,1.563,1.342,1.342,0,0,0,1.535-1.128A10.53,10.53,0,0,1,5.268,6.153a10.649,10.649,0,0,1,15.211-.461,11.358,11.358,0,0,1,3.66,8.7,1.339,1.339,0,1,0,2.676.089A14.018,14.018,0,0,0,25.9,9.013"
            transform="translate(-0.019 0)"
            fill="#707070"
          />
          <path
            id="Caminho_241"
            data-name="Caminho 241"
            d="M2.013,22.26a1.512,1.512,0,0,0,.841-1.945A1.469,1.469,0,0,0,.942,19.46,1.51,1.51,0,0,0,.1,21.4a1.469,1.469,0,0,0,1.912.855"
            transform="translate(0 -5.739)"
            fill="#707070"
          />
          <path
            id="Caminho_242"
            data-name="Caminho 242"
            d="M3.988,27.772a1.512,1.512,0,0,0,.841-1.945,1.469,1.469,0,0,0-1.912-.855,1.51,1.51,0,0,0-.841,1.945,1.469,1.469,0,0,0,1.912.855"
            transform="translate(-0.609 -7.373)"
            fill="#707070"
          />
        </g>
      </g>
    </svg>
  )
}

export default SearchAnyProductIcon
